export default __webpack_public_path__ + "static/media/pharmacyPortal2.766a50c6.png";